import BalanceWETH from '../constants/contractABI/BalanceWETH';
import BalanceWMATIC from '../constants/contractABI/BalanceWMATIC';

export const getABIFile = (currency: string) => {
  if (currency === 'WETH') {
    return BalanceWETH.abi;
  }

  return BalanceWMATIC.abi;
};
